import { render } from "./SendMessage.vue?vue&type=template&id=edf3436a"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__